<script lang="ts">
  import { EventTracking } from "@shared/services/event_tracking/events";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import SavedProduct from "@retailer/svelte/Cart/SavedForLater/SavedProduct.svelte";
  import type { SavedProductType } from "@shared/types/SavedProducts";
  import CloudinaryImageService from "@shared/svelte/Modules/CloudinaryImageService";
  import { pluralize } from "@shared/svelte/Modules/pluralize";
  import { DistributorEntity } from "@shared/services/event_tracking/entities";

  export let callbacks;
  export let cartService;
  export let isMobile: boolean = false;
  export let products: SavedProductType[];
  export let distributorName: string;
  export let showLoading: boolean = false;

  let accordionOpen: boolean = true;
  let distributor = products[0].distributor;
  let imageUrl = distributor?.cloudinary_image_url;
  const { trackClick } = EventTracking;

  const onClickWrapper = () => {
    // accordionOpen will not be updated by the bind before this callback is called.
    // This means if accordionOpen is true, then we are now collapsing the accordion.
    const eventType = accordionOpen ? "collapse_accordion" : "expand_accordion";
    trackClick(eventType, [new DistributorEntity({ id: distributor.id })]);
  };

  $: itemString = pluralize("item", products.length, true);
</script>

<details
  class="fizz-accordion fizz-accordion-icon-lg"
  bind:open={accordionOpen}
  on:click={onClickWrapper}
  on:keypress={onClickWrapper}
>
  <summary>
    <div class="fizz-flex-row fizz-space-between">
      <div class="fizz-flex-row-12 fizz-flex-item">
        <div
          class="fizz-bordered icon-container fizz-flex-no-shrink fizz-icon-32"
          data-testid="save-for-later-accordion"
        >
          {#if imageUrl}
            <img
              on:error={() => (imageUrl = null)}
              class="logo"
              src={CloudinaryImageService.getUrl(imageUrl, 75, 75)}
              alt="Logo"
            />
          {:else}
            <Icon type="DistributorLogoPlaceholder" extraStyles="height: 30px; width: 30px;" />
          {/if}
        </div>
        <div class="fizz-flex-vertical">
          <div class="fizz-text-strong">
            {distributorName}
          </div>
          {#if isMobile}
            <div class="fizz-text-subdued">
              {itemString}
            </div>
          {/if}
        </div>
      </div>
      {#if !isMobile}
        <div class="fizz-inset-horizontal-8">
          {itemString}
        </div>
      {/if}
    </div>
  </summary>
  <div class:fizz-border-top={!isMobile}>
    {#each products as savedProduct (savedProduct.id)}
      <SavedProduct {savedProduct} {callbacks} {cartService} {isMobile} bind:showLoading />
    {/each}
  </div>
</details>
